import { KycSettings } from 'src/packages/common/header/Header.types';

export const useKycRules = (kycSettings: KycSettings | undefined) => {
  const allowDeposit =
    !kycSettings || !kycSettings?.hasOwnProperty('allowDeposit')
      ? true
      : !!kycSettings?.allowDeposit;
  const allowTrading =
    !kycSettings || !kycSettings?.hasOwnProperty('allowTrading')
      ? true
      : !!kycSettings?.allowTrading;
  const earnPlatformAllowed =
    !kycSettings || !kycSettings?.hasOwnProperty('earnPlatformAllowed')
      ? true
      : !!kycSettings?.earnPlatformAllowed;
  const convertPlatformAllowed =
    !kycSettings || !kycSettings?.hasOwnProperty('convertPlatformAllowed')
      ? true
      : !!kycSettings?.convertPlatformAllowed;
  const tradingSpotAllowed =
    !kycSettings || !kycSettings?.hasOwnProperty('tradingSpotAllowed')
      ? true
      : !!kycSettings?.tradingSpotAllowed;
  const tradingDerivativesAllowed =
    !kycSettings || !kycSettings?.hasOwnProperty('tradingDerivativesAllowed')
      ? true
      : !!kycSettings?.tradingDerivativesAllowed;

  const isSymbolAllowed =
    kycSettings && kycSettings.isSymbolAllowed && typeof kycSettings.isSymbolAllowed === 'function'
      ? kycSettings.isSymbolAllowed
      : (_value?: any) => true;

  return {
    allowDeposit,
    allowTrading,
    earnPlatformAllowed,
    convertPlatformAllowed,
    tradingSpotAllowed,
    tradingDerivativesAllowed,
    isSymbolAllowed,
  };
};
